<template>
  <div class="grid-view charge-search-tab">
    <div class="main-content" style="overflow-y: auto;">
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="185010"
          :grid-options="gridOptions"
          :export-file-name="filename"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :show-row-groups="dataListDragGroup"
          @saveColumnState="saveColumnState"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper amount-sum" style="flex-wrap: unset;align-items: unset;padding: 2px 5px;line-height: 28px;">
        <div style="display: flex;flex-direction: row-reverse;min-width: 600px">
          <job-amount-sum-by-currency
            key="amountSumByCurrency"
            :data-provider="dataProvider"
            cache-prefix="jobTab"
            @callback="onSumCallbak"
          />
          <amount-sum-master-bold
            key="sumJobEquivalentRMB"
            ref="sumJobEquivalentRMB"
            datafield="EQUIVALENT_RMB"
            :title="$t('CargoMsg.Cargo_ConversionProfitCNYP')"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentPayable"
            ref="sumJobRmbEquivalentPayable"
            datafield="PAY_EQUIVALENT_RMB"
            :title="$t('CargoMsg.Cargo_ConversionAPCNY') + ':'"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentReceiveable"
            ref="sumJobRmbEquivalentReceiveable"
            datafield="RECEIVE_EQUIVALENT_RMB"
            :title="$t('CargoMsg.Cargo_ConversionARCNY') + ':'"
            :data-provider="rowData"
          />
        </div>
        <!-- <amount-sum-master
          key="sumJobUnpaid"
          ref="sumJobUnpaid"
          datafield="PAY_UN_"
          :has-muti-currency="true"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_UnpaidP')"
          :data-provider="rowData"
          :fit-screen1366="true"
        />
        <amount-sum-master
          key="sumJobNotReceived"
          ref="sumJobNotReceived"
          datafield="RECEIVE_UN_"
          :has-muti-currency="true"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_NotCollectedP')"
          :data-provider="rowData"
          :fit-screen1366="true"
        />
        <amount-sum-master
          key="sumJobPayable"
          ref="sumJobPayable"
          datafield="PAY_"
          :has-muti-currency="true"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_DuesP')"
          :data-provider="rowData"
          :fit-screen1366="true"
        />
        <amount-sum-master
          key="sumJobReceivable"
          ref="sumJobReceivable"
          datafield="RECEIVE_"
          :has-muti-currency="true"
          :title="$t('CargoMsg.Cargo_ReceivableP')"
          :data-provider="rowData"
        /> -->
        <div style="flex-grow: 1;display: inline-flex;flex-wrap: wrap;">
          <template v-if="!showSumPop">
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsReceivable') }}</span>
              <div v-for="(item,index) in arCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsPayable') }}</span>
              <div v-for="(item,index) in apCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
          </template>
        </div>
        <div style="display: inline-flex;min-width: 150px">
          <div>{{ $t('CargoMsg.Cargo_AllAmountP')+rowData.length }}</div>
          <div style="margin: 0px 10px;">{{ $t('CargoMsg.Cargo_SelectedItems',['['+numSelected+']']) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import AmountSumMasterBold from './AmountSumMasterBold'
import JobAmountSumByCurrency from './JobAmountSumByCurrency'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import * as NumberUtils from '@/utils/NumberUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { getJumpFinaceOrBusinessAttrs } from '@/components/Cargo/grid/routerAndPrintHelp'
import { getCacheListByKey } from '@/utils/basicDataCache'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import { stringToBool } from '@/utils/commonUtil'

export default {
  name: 'JobTab',
  components: { CargoAgGridWrapper, AmountSumMasterBold, JobAmountSumByCurrency },
  props: {
    filename: { type: String, default: '' },
    data: { type: Array, required: true },
    rowDataChanged: {
      type: Function, default: () => {
      }
    },
    conversionCurrencySet: { type: Object, default: () => ({}) },
    perConfigName: { type: String, default: '' },
    gridRefreshId: { type: Number, default: 0 }
  },
  data() {
    // const amountSum = this.$store.getters.isLowerThenScreen1366
    //   ? { id: '', class: '', style: 'display: flex;flex-direction: row;overflow-x: auto' }
    //   : { id: 'footer-wrapper', class: 'pagination-wrapper amount-sum', style: '' }
    return {
      loading: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: this.rowDataChanged,
        context: {
          componentParent: this
        }
      },
      columnDefs: [],
      currencyColumnDefs: [],
      specialExpenseColumnDefs: [],
      rowData: [],
      dataProvider: [],
      // amountSum
      numSelected: 0,
      showSumPop: false, // 是否显示合计弹窗
      arCurrencySum: [],
      apCurrencySum: [],
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      isSpecialExpenseEntryFunction: false, // 专项费用录入功能配置
      currencyRateMap: new Map() // 币种汇率映射
    }
  },
  computed: {
    finalColumnDefs() {
      if (this.isSpecialExpenseEntryFunction) {
        return [...this.columnDefs, ...this.currencyColumnDefs, ...this.specialExpenseColumnDefs]
      } else {
        return [...this.columnDefs, ...this.currencyColumnDefs]
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    data(newVal) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'UUID')
      this.rowData = newVal
      this.toStatisticsCurrency()
      this.dataProvider = this.rowData
      selectedStatus.revert()
    },
    conversionCurrencySet() {
      this.toStatisticsCurrency()
    }
  },
  created() {
    this.rowData = this.data
    this.toStatisticsCurrency()
    this.dataProvider = this.rowData
    this.initConfig()
  },
  beforeMount() {
    this.gridOptions.onSelectionChanged = (event) => {
      this.onCheckBoxClick(event)
    }
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'JOB_NO', width: 180,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          tag: 'router-and-print',
          attrs: params => {
            const data = params.data
            return getJumpFinaceOrBusinessAttrs(true, false, data.JOB_NO, data.LOB, data.OP_OFFICE)
          }
        }},
      { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'PONO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'LOB', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.jobBussStateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'), field: 'CUSTOMER_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0')
        } },
      { headerName: this.$t('CargoMsg.Cargo_MblNo'), field: 'MBL', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_BusinessStatus'), field: 'JOB_STATE', width: 180, enableRowGroup: true,

        cellRenderer: (params) => {
          return ColumnUtils.jobStateLabelFunc(Number(params.value))
        } },
      { headerName: this.$t('CargoMsg.Cargo_SeparateNumber'), field: 'HBL', width: 180, enableRowGroup: true },

      { headerName: this.$t('SeaExport.CustomJobType'), field: 'CUSTOM_JOB_TYPE', width: 180, enableRowGroup: true,
        valueGetter: (params) => {
          return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.CUSTOM_JOB_TYPE, 'name', params.data.LOB, params.data.FBA)
        }
      },

      { headerName: 'ETD', field: 'ETD', width: 120, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        } },
      { headerName: 'ETA', field: 'ETA', width: 120, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATD', field: 'ATD', width: 120, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATA', field: 'ATA', width: 120, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('SeaExport.DateOfDelivery'), field: 'DELIVER_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('SeaExport.DateOfArrivalTheWarehouse'), field: 'ARRIVE_STORAGE_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },

      { headerName: this.$t('CargoMsg.Cargo_ChineseFirstVesselName'), field: 'VESSEL', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_FlightVoyage'), field: 'VOYAGE_FLIGHT', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_CustomerReferenceNumber'), field: 'CUSTOMER_REF_NO', width: 180, enableRowGroup: true },

      { headerName: 'SO NO', field: 'SO_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableUSD'), field: 'RECEIVE_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesUSD'), field: 'PAY_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableCNY'), field: 'RECEIVE_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedCNY'), field: 'RECEIVED_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesCNY'), field: 'PAY_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidCNY'), field: 'PAY_PAID_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ConversionProfitCNY'), field: 'EQUIVALENT_RMB', width: 180,
        cellRenderer: params => {
          let amount = 0
          const item = params.data
          if (item) {
            const arAmount = item['RECEIVE_EQUIVALENT_RMB'] ? NumberUtils.formatNumber(item['RECEIVE_EQUIVALENT_RMB'], 2, true) : item['RECEIVE_EQUIVALENT_RMB']
            const apAmount = item['PAY_EQUIVALENT_RMB'] ? NumberUtils.formatNumber(item['PAY_EQUIVALENT_RMB'], 2, true) : item['PAY_EQUIVALENT_RMB']
            amount = NumberUtils.formatNumber(arAmount - apAmount, 2, true)
          }
          return ColumnUtils.formatNumberReturnZero(isNaN(amount) ? 0 : Number(amount), 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableEUR'), field: 'RECEIVE_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesEUR'), field: 'PAY_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableHKD'), field: 'RECEIVE_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      {
        headerName: this.$t('SeaExport.AirlinePerson2'),
        field: 'PLANNER',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        width: 180
      },
      {
        headerName: this.$t('SeaExport.SalesOfGoods'),
        field: 'CARGO_SALES_ID',
        enableRowGroup: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales')
        },
        width: 180
      },
      { headerName: this.$t('CargoMsg.Cargo_DuesHKD'), field: 'PAY_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableNGN'), field: 'RECEIVE_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedNGN'), field: 'RECEIVED_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidNGN'), field: 'PAY_PAID_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      {
        headerName: this.$t('SeaExport.WarehouseNo'),
        field: 'WAREHOUSE_NO',
        hide: true,
        enableRowGroup: true,
        width: 180
      }, { headerName: this.$t('CargoMsg.Cargo_DuesNGN'), field: 'PAY_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARCNY'), field: 'RECEIVE_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedCNY'), field: 'RECEIVED_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPCNY'), field: 'PAY_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidCNY'), field: 'PAY_PAID_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAREUR'), field: 'RECEIVE_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPEUR'), field: 'PAY_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedEUR'), field: 'RECEIVED_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidEUR'), field: 'PAY_PAID_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARHKD'), field: 'RECEIVE_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPHKD'), field: 'PAY_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedHKD'), field: 'RECEIVED_OTHER_HKD', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidHKD'), field: 'PAY_PAID_OTHER_HKD', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARNGN'), field: 'RECEIVE_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPNGN'), field: 'PAY_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionReceivedNGN'), field: 'RECEIVED_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionPayPaidNGN'), field: 'PAY_PAID_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      // { headerName: this.$t('CargoMsg.Cargo_ConversionARCNY'), field: 'RMB_EQUIVALENT_RECEIVEABLE', width: 180,
      { headerName: this.$t('CargoMsg.Cargo_ConversionARCNY'), field: 'RECEIVE_EQUIVALENT_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_ConversionReceivedCNY'), field: 'RECEIVED_EQUIVALENT_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum'
      },
      // CARGO-33528 现将折合CNY相关改为合计对应业务所有费用，不针对特定几个币种
      // { headerName: this.$t('CargoMsg.Cargo_ConversionAPCNY'), field: 'RMB_EQUIVALENT_PAYABLE', width: 180,
      { headerName: this.$t('CargoMsg.Cargo_ConversionAPCNY'), field: 'PAY_EQUIVALENT_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ConversionPaidCNY'), field: 'PAY_PAID_EQUIVALENT_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedUSD'), field: 'RECEIVE_UN_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedUSD'), field: 'RECEIVED_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidUSD'), field: 'PAY_PAID_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidUSD'), field: 'PAY_UN_USD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedCNY'), field: 'RECEIVE_UN_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidCNY'), field: 'PAY_UN_RMB', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedEUR'), field: 'RECEIVE_UN_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedEUR'), field: 'RECEIVED_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidEUR'), field: 'PAY_PAID_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidEUR'), field: 'PAY_UN_EUR', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedHKD'), field: 'RECEIVE_UN_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedHKD'), field: 'RECEIVED_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidHKD'), field: 'PAY_PAID_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidHKD'), field: 'PAY_UN_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedNGN'), field: 'RECEIVE_UN_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidNGN'), field: 'PAY_UN_NGN', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivableJPY'), field: 'RECEIVE_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_DuesJPY'), field: 'PAY_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ReceivedJPY'), field: 'RECEIVED_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_PayPaidJPY'), field: 'PAY_PAID_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotCollectedJPY'), field: 'RECEIVE_UN_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_UnpaidJPY'), field: 'PAY_UN_JPY', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionARJPY'), field: 'receiveOther', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherConversionAPJPY'), field: 'payOther', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARJPY'), field: 'receiveUnOther', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPJPY'), field: 'payUnOther', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARCNY'), field: 'RECEIVE_UN_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPCNY'), field: 'PAY_UN_OTHER', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAREUR'), field: 'RECEIVE_UN_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPEUR'), field: 'PAY_UN_OTHER_EUR', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARHKD'), field: 'RECEIVE_UN_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPHKD'), field: 'PAY_UN_OTHER_HKD', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionARNGN'), field: 'RECEIVE_UN_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_OtherOutstandingConversionAPNGN'), field: 'PAY_UN_OTHER_NGN', width: 180,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      // { headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingARCNY'), field: 'RMB_NOT_RECEIVEABLE', width: 180,
      { headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingARCNY'), field: 'RECEIVE_UN_AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum'
      },
      // { headerName: this.$t('CargoMsg.Cargo_OutstandingConversionAPInCNY'), field: 'RMB_NOT_PAYABLE', width: 180,
      { headerName: this.$t('CargoMsg.Cargo_OutstandingConversionAPInCNY'), field: 'PAY_UN_AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_IsShutOut'), field: 'SHUT_OUT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        } },
      { headerName: this.$t('CargoMsg.Cargo_PortOfLoading'), field: 'LOADING_PORT_CODE', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.portLabelFuncByFinance(params.data, params.value)
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_DestinationPort'), field: 'DESTINATION_PORT_CODE', width: 180,
        cellRenderer: (params) => {
          if (params.data.LOB === 'SI') {
            return ColumnUtils.portLabelFuncByFinance(params.data, params.data.DISCHARGING_PORT_CODE)
          }
          return ColumnUtils.portLabelFuncByFinance(params.data, params.value)
        },
        filter: false,
        filterParams: {}
      },

      { headerName: this.$t('CargoMsg.Cargo_ActualQuantity'), field: 'QUANTITY_ACTUAL', width: 180, enableRowGroup: true,
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ActualWeight'), field: 'WEIGHT_ACTUAL', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_ActualVolume'), field: 'CUBAGE_ACTUAL', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },

      { headerName: this.$t('CargoMsg.Cargo_ActualChargedWeight'), field: 'CHARGE_WEIGHT', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'OP_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_Sales'), field: 'SALES_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_SalesDepartment'), field: 'SALES_DEPT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'DC_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_CustomerService'), field: 'CSR_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_SolicitationType'), field: 'CARGO_SOURCE', width: 180, enableRowGroup: true, cellRenderer: (params) => {
        return ColumnUtils.cargoSourceLabelFunction(params.value)
      } },
      { headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'CARRIER_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_NominatedAgent'), field: 'DESIGNATION_AGENT', width: 180, enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        } },
      { headerName: this.$t('CargoMsg.Cargo_ContainerTypeSea'), field: 'S_CONTAINER_LOAD_TYPE', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction2(params.data, 'S_CONTAINER_LOAD_TYPE')
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_OperationModeAir'), field: 'A_OPERATE_TYPE', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.operateTypeLabelFunc2(params.data, 'A_OPERATE_TYPE')
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_DelegationTypeRailway'), field: 'R_CONTAINER_LOAD_TYPE', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'R_CONTAINER_LOAD_TYPE')
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('CargoMsg.Cargo_ContainerNo'), field: 'CONTAINER_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_ContainerDescription'), field: 'CONTAINER_DESC', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.containerDescLabelFuncForChargeSearch(params.value)
        },
        filter: false,
        filterParams: {}
      },
      { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'USER_DEFINED_FIELD_1', width: 180, enableRowGroup: true },
      { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'USER_DEFINED_FIELD_2', width: 180, enableRowGroup: true },
      { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'USER_DEFINED_FIELD_3', width: 180, enableRowGroup: true },
      { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'USER_DEFINED_FIELD_4', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_Accrued'), field: 'PROVISIONED', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_OperationDate'), field: 'CUSTOMS_DATE', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Airline'),
        field: 'airLine', width: 100,
        valueFormatter: (params) => {
          return ColumnUtils.airLineLabelFunction(params.data, 'airLine')
        },
        filterParams: {},
        filterValueGetter: (params) => {
          return ColumnUtils.airLineLabelFunction(params.data, 'airLine')
        }
      }, {
        headerName: this.$t('SeaExport.MasterBusinessNo'),
        colId: 'masterJobNo',
        field: 'masterJobNo',
        width: 150,
        enableRowGroup: true,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_khPlateNumber'),
        field: 'khPlateNumber',
        colId: 'khPlateNumber',
        width: 120,
        enableRowGroup: true,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_khTrailerNumber'),
        field: 'khTrailerNumber',
        colId: 'khTrailerNumber',
        width: 120,
        enableRowGroup: true,
        hide: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
        field: 'BOOKING_AGENT',
        colId: 'BOOKING_AGENT',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('CargoMsg.Cargo_ShippingCompanyContractNo'),
        field: 'SC_NO',
        colId: 'SC_NO',
        enableRowGroup: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
        field: 'DISCHARGING_PLACE',
        colId: 'DISCHARGING_PLACE',
        enableRowGroup: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
        field: 'ACT_TAKE_TIME',
        colId: 'ACT_TAKE_TIME',
        enableRowGroup: true,
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_DepartureStation'),
        colId: 'departureStation',
        field: 'departureStation',
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        hide: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_DestinationStation'),
        colId: 'destinationStation',
        field: 'destinationStation',
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        hide: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_TransitStation'),
        colId: 'transitStation',
        field: 'transitStation',
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        hide: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_TransferStation'),
        colId: 'transferStation',
        field: 'transferStation',
        enableRowGroup: true,
        cellRenderer: params => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'auto_railway') : ''
        },
        hide: true,
        width: 120
      },
      {
        headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
        colId: 'receivableInvoiceState',
        field: 'receivableInvoiceState',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
        colId: 'payableInvoiceState',
        field: 'payableInvoiceState',
        width: 180,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ContractRateProperty'),
        colId: 'bookingTerm',
        field: 'bookingTerm',
        width: 180,
        enableRowGroup: true,
        valueFormatter: (params) => {
          return ColumnUtils.bookingTermSILabelFunction(params.data, params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'OVERSEA_OP', width: 180, colId: 'OVERSEA_OP', hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('FinanceManage.Peer'), field: 'peer', width: 100, colId: 'peer', hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        }
      }, {
        headerName: this.$t('SeaExport.PortOfDischargeSeaAndComprehensive'),
        colId: 'DISCHARGING_PORT_CODE',
        field: 'DISCHARGING_PORT_CODE',
        enableRowGroup: true,
        hide: true,
        valueGetter: (params) => {
          return ColumnUtils.portLabelFuncBySeaAndComprehensive(params.data, params.data.DISCHARGING_PORT_CODE)
        },
        width: 170
      }, {
        headerName: this.$t('SeaExport.DestinationPortCountry'),
        colId: 'DESTINATION_PORT_COUNTRY_CODE',
        field: 'DESTINATION_PORT_COUNTRY_CODE',
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
        },
        width: 170
      }, {
        headerName: this.$t('SeaExport.DischargingPortCountry'),
        colId: 'DISCHARGING_PORT_COUNTRY_CODE',
        field: 'DISCHARGING_PORT_COUNTRY_CODE',
        enableRowGroup: true,
        hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
        },
        width: 170
      }, {
        headerName: this.$t('CargoMsg.Cargo_OperationDepartment'),
        field: 'OP_DEPARTMENT',
        colId: 'OP_DEPARTMENT',
        hide: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', Number(params.value), 'chineseName')
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('Billing.billingCharge_bookingNo'),
        field: 'bookingNo',
        colId: 'bookingNo',
        width: 200,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('SeaExport.PlateNumber'),
        field: 'plateNumber',
        width: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_BusinessDate'),
        field: 'BUSINESS_DATE',
        width: 180,
        hide: true,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_AuditDate'),
        field: 'FC_AUDIT_DATE',
        width: 180,
        hide: true,
        enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      }
    ]
    this.specialExpenseColumnDefs = [{
      headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableTotal'),
      colId: 'specialChargeApSum',
      field: 'specialChargeApSum',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableCurrency'),
      colId: 'specialChargeApCurrency',
      field: 'specialChargeApCurrency',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableTotal'),
      colId: 'specialChargeArSum',
      field: 'specialChargeArSum',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableCurrency'),
      colId: 'specialChargeArCurrency',
      field: 'specialChargeArCurrency',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }]
  },
  methods: {
    saveColumnState() {
      this.$emit('saveColumnState')
    },
    onCheckBoxClick(event) {
      const selections = getGridSelected(this.gridOptions)
      this.numSelected = selections.length
      if (selections.length > 0) {
        this.loading = getLoading()
        // this.$refs.sumJobReceivable.setDataProvider(selections, event)
        // this.$refs.sumJobPayable.setDataProvider(selections, event)
        // this.$refs.sumJobNotReceived.setDataProvider(selections, event)
        // this.$refs.sumJobUnpaid.setDataProvider(selections, event)
        this.$refs.sumJobEquivalentRMB.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentPayable.setDataProvider(selections)
        this.dataProvider = selections
        this.loading.close()
      } else {
        this.$nextTick(() => {
          this.loading = getLoading()
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              // this.$refs.sumJobReceivable.setDataProvider(this.rowData, event)
              // this.$refs.sumJobPayable.setDataProvider(this.rowData, event)
              // this.$refs.sumJobNotReceived.setDataProvider(this.rowData, event)
              // this.$refs.sumJobUnpaid.setDataProvider(this.rowData, event)
              this.$refs.sumJobEquivalentRMB.setDataProvider(this.rowData)
              this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(this.rowData)
              this.$refs.sumJobRmbEquivalentPayable.setDataProvider(this.rowData)
              this.dataProvider = this.rowData
            }
            if (hasDisplay.length < this.rowData.length) {
              // this.$refs.sumJobReceivable.setDataProvider(hasDisplay, event)
              // this.$refs.sumJobPayable.setDataProvider(hasDisplay, event)
              // this.$refs.sumJobNotReceived.setDataProvider(hasDisplay, event)
              // this.$refs.sumJobUnpaid.setDataProvider(hasDisplay, event)
              this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
              this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
              this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
              this.dataProvider = hasDisplay
            }
          } else {
            // this.$refs.sumJobReceivable.setDataProvider(hasDisplay, event)
            // this.$refs.sumJobPayable.setDataProvider(hasDisplay, event)
            // this.$refs.sumJobNotReceived.setDataProvider(hasDisplay, event)
            // this.$refs.sumJobUnpaid.setDataProvider(hasDisplay, event)
            this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
            this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
            this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
            this.dataProvider = hasDisplay
          }
          this.loading.close()
        })
      }
    },
    onSumCallbak(data) {
      this.showSumPop = data.showPop
      this.arCurrencySum = data.arCurrencySum
      this.apCurrencySum = data.apCurrencySum
    },
    toStatisticsCurrency(rowData) {
      if (!rowData) {
        rowData = this.rowData
      }
      const currencyColumnDefs1 = this.toStatisticsOriginCurrency(rowData)
      const currencyColumnDefs2 = this.toStatisticsConversionCurrency(rowData)
      this.currencyColumnDefs = [...currencyColumnDefs1, ...currencyColumnDefs2]
    },
    toStatisticsOriginCurrency() {
      const currencyColumnDefs = []
      const { currencies, originReceivable, originPayable, originNotCollected, originNotPaid, originReceived, originPaid } = this.conversionCurrencySet
      if (!(currencies && currencies.length > 0 && typeof originReceivable === 'boolean' && typeof originPayable === 'boolean' &&
        typeof originNotCollected === 'boolean' && typeof originNotPaid === 'boolean' && typeof originReceived === 'boolean' &&
        typeof originPaid === 'boolean' && (originReceivable || originPayable || originNotCollected || originNotPaid || originReceived || originPaid))) {
        return currencyColumnDefs
      }
      for (const currency of currencies) {
        if (currency === 'CNY') {
          continue
        }
        if (currency === 'RMB') {
          if (originReceivable) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyReceivable', [currency]),
              field: 'RECEIVE_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVE_RMB'], 2, true)
              }
            })
          }
          if (originPayable) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyPayable', [currency]),
              field: 'PAY_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_RMB'], 2, true)
              }
            })
          }
          if (originNotCollected) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyNotReceived', [currency]),
              field: 'RECEIVE_UN_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVE_UN_RMB'], 2, true)
              }
            })
          }
          if (originNotPaid) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyUnpaid', [currency]),
              field: 'PAY_UN_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_UN_RMB'], 2, true)
              }
            })
          }
          if (originReceived) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyReceived', [currency]),
              field: 'RECEIVED_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVED_RMB'], 2, true)
              }
            })
          }
          if (originPaid) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.CurrencyPaid', [currency]),
              field: 'PAY_PAID_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_PAID_RMB'], 2, true)
              }
            })
          }
        } else {
          if (originReceivable) {
            const field = 'RECEIVE_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyReceivable', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originPayable) {
            const field = 'PAY_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyPayable', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originNotCollected) {
            const field = 'RECEIVE_UN_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyNotReceived', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originNotPaid) {
            const field = 'PAY_UN_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyUnpaid', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originReceived) {
            const field = 'RECEIVED_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyReceived', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
          if (originPaid) {
            const field = 'PAY_PAID_' + currency
            if (!this.isExistField(field)) {
              currencyColumnDefs.push({
                headerName: this.$t('CargoMsg.CurrencyPaid', [currency]),
                field,
                width: 180,
                cellRenderer: params => {
                  return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
                }
              })
            }
          }
        }
      }
      return currencyColumnDefs
    },
    isExistField(field) {
      return this.columnDefs.findIndex(p => p.field === field) > -1
    },
    toStatisticsConversionCurrency(rowData) {
      const currencyColumnDefs = []
      const { currencies, receivable, payable, notCollected, notPaid, received, paid } = this.conversionCurrencySet
      if (!(currencies && currencies.length > 0 && typeof receivable === 'boolean' && typeof payable === 'boolean' &&
        typeof notCollected === 'boolean' && typeof notPaid === 'boolean' && typeof received === 'boolean' && typeof paid === 'boolean' && (receivable || payable || notCollected || notPaid || received || paid))) {
        return currencyColumnDefs
      }
      const allCurrencyInfo = getCacheListByKey(TYPE_NAMES.basic_data_Currency)
      for (const currency of currencies) {
        if (currency === 'CNY') {
          continue
        }
        if (currency === 'RMB') {
          if (receivable) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.Cargo_ConversionARCurrency', [currency]),
              field: 'RECEIVE_EQUIVALENT_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVE_EQUIVALENT_RMB'], 2, true)
              }
            })
          }
          if (payable) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.Cargo_ConversionAPCurrency', [currency]),
              field: 'PAY_EQUIVALENT_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_EQUIVALENT_RMB'], 2, true)
              }
            })
          }
          if (notCollected) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingARCurrency', [currency]),
              field: 'RECEIVE_UN_EQUIVALENT_RMB',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVE_UN_AMOUNT'], 2, true)
              }
            })
          }
          if (notPaid) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.Cargo_OutstandingConversionAPInCurrency', [currency]),
              field: 'PAY_UN_EQUIVALENT_RMB',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_UN_AMOUNT'], 2, true)
              }
            })
          }
          if (received) {
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingReceivedCurrency', [currency]),
              field: 'RECEIVED_EQUIVALENT_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['RECEIVED_EQUIVALENT_RMB'], 2, true)
              }
            })
          }
          if (paid) {
            for (const row of rowData) {
              let payPaidSum = 0
              for (const { code } of allCurrencyInfo) {
                let rate = this.getRate(currency, code)
                if (rate === Infinity) rate = 0
                payPaidSum += (row['PAY_PAID_' + code] || 0) * rate
              }
              row['PAY_PAID_EQUIVALENT_RMB'] = payPaidSum
            }
            currencyColumnDefs.push({
              headerName: this.$t('CargoMsg.Cargo_OutstandingConversionPaidInCurrency', [currency]),
              field: 'PAY_PAID_EQUIVALENT_RMB2',
              width: 180,
              cellRenderer: params => {
                return ColumnUtils.formatNumberReturnZero(params.data['PAY_PAID_EQUIVALENT_RMB'], 2, true)
              }
            })
          }
          continue
        }
        const receiveEquivalentField = 'RECEIVE_EQUIVALENT_' + currency
        const payEquivalentField = 'PAY_EQUIVALENT_' + currency
        const receiveUnEquivalentField = 'RECEIVE_UN_EQUIVALENT_' + currency
        const payUnEquivalentField = 'PAY_UN_EQUIVALENT_' + currency
        const receivedEquivalentField = 'RECEIVED_EQUIVALENT_' + currency
        const payPaidField = 'PAY_PAID_EQUIVALENT_' + currency
        if (receivable) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionARCurrency', [currency]),
            field: receiveEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (payable) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionAPCurrency', [currency]),
            field: payEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (notCollected) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingARCurrency', [currency]),
            field: receiveUnEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (notPaid) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_OutstandingConversionAPInCurrency', [currency]),
            field: payUnEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (received) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_ConversionOutstandingReceivedCurrency', [currency]),
            field: receivedEquivalentField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        if (paid) {
          currencyColumnDefs.push({
            headerName: this.$t('CargoMsg.Cargo_OutstandingConversionPaidInCurrency', [currency]),
            field: payPaidField,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.formatNumberReturnZero(params.value, 2, true)
            }
          })
        }
        for (const row of rowData) {
          if (row.hasOwnProperty(receiveEquivalentField) && row.hasOwnProperty(payEquivalentField) && row.hasOwnProperty(receiveUnEquivalentField) && row.hasOwnProperty(payUnEquivalentField) && row.hasOwnProperty(receivedEquivalentField) && row.hasOwnProperty(payPaidField)) {
            break
          }
          let receiveEquivalentSum = 0
          let payEquivalentSum = 0
          let receiveUnEquivalentSum = 0
          let payUnEquivalentSum = 0
          let receivedEquivalentSum = 0
          let payPaidSum = 0
          for (const { code } of allCurrencyInfo) {
            let rate = this.getRate(currency, code)
            if (rate === Infinity) {
              rate = 0
            }
            receiveEquivalentSum += (row['RECEIVE_' + code] || 0) * rate
            payEquivalentSum += (row['PAY_' + code] || 0) * rate
            receiveUnEquivalentSum += (row['RECEIVE_UN_' + code] || 0) * rate
            payUnEquivalentSum += (row['PAY_UN_' + code] || 0) * rate
            receivedEquivalentSum += (row['RECEIVED_' + code] || 0) * rate
            payPaidSum += (row['PAY_PAID_' + code] || 0) * rate
          }
          row[receiveEquivalentField] = receiveEquivalentSum
          row[payEquivalentField] = payEquivalentSum
          row[receiveUnEquivalentField] = receiveUnEquivalentSum
          row[payUnEquivalentField] = payUnEquivalentSum
          row[receivedEquivalentField] = receivedEquivalentSum
          row[payPaidField] = payPaidSum
        }
      }
      return currencyColumnDefs
    },
    getRate(sourceCurrency, targetCurrency) {
      if (sourceCurrency === targetCurrency) {
        return 1
      }
      const key = `${sourceCurrency}-${targetCurrency}`
      if (this.currencyRateMap.has(key)) {
        return this.currencyRateMap.get(key)
      } else {
        const rate = RateUtil.getForeignExchangeRateSafely(sourceCurrency, targetCurrency, new Date(), 0, 0)
        this.currencyRateMap.set(key, rate)
        return rate
      }
    },
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    }
  }
}
</script>

<style scoped>

</style>
